/**
 * Mercado Pago Frontend Service
 * Helper functions to verify integration status & admin reset tools
 */

import { getPaymentsStatus, MercadoPagoIntegrationStatus } from './payments';
import { apiClient, ApiResponse } from './apiClient';

export interface ResetStatus {
  canReset: boolean;
  environment: string;
  available?: boolean;
}

export async function getMercadoPagoStatus(): Promise<MercadoPagoIntegrationStatus> {
  try {
    const res = await getPaymentsStatus();
    if (res.success && res.data) {
      return res.data;
    }
    return {
      configured: false,
      environment: 'development',
      accessTokenPresent: false,
    };
  } catch {
    return {
      configured: false,
      environment: 'development',
      accessTokenPresent: false,
    };
  }
}

export async function getResetStatus(): Promise<ApiResponse<ResetStatus>> {
  return apiClient.get('/admin/reset/status');
}

export async function resetSystemData(): Promise<
  ApiResponse<{ message: string; counts?: Record<string, number>; deletedCounts?: Record<string, number> }>
> {
  return apiClient.post('/admin/reset/data');
}
